let n = Date.now();

export default function () {
    return (++n).toString(36);
}
